import { render, staticRenderFns } from "./publishHighSetting.vue?vue&type=template&id=1dcfe415&scoped=true&"
import script from "./publishHighSetting.vue?vue&type=script&lang=js&"
export * from "./publishHighSetting.vue?vue&type=script&lang=js&"
import style0 from "./publishHighSetting.vue?vue&type=style&index=0&id=1dcfe415&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcfe415",
  null
  
)

export default component.exports